import { render } from "./DataOverview.vue?vue&type=template&id=7ed0c844&scoped=true"
import script from "./DataOverview.vue?vue&type=script&lang=js"
export * from "./DataOverview.vue?vue&type=script&lang=js"

import "./DataOverview.vue?vue&type=style&index=0&id=7ed0c844&lang=scss&scoped=true"
import "./DataOverview.vue?vue&type=style&index=1&id=7ed0c844&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed0c844"]])

export default __exports__